"use client";

import SearchBar from "@/components/global/SearchBar";
import Navbar from "@/components/global/Navbar";
import { usePathname } from "next/navigation";

interface HeaderProps {
  hideCategoryIcon?: boolean;
  hideAvatarIcon?: boolean;
}

export default function Header({
  hideCategoryIcon = false,
  hideAvatarIcon = false,
}: HeaderProps) {
  const pathname = usePathname();
  const showSimpleNavbar =
    !pathname.includes("/checkout") &&
    !pathname.includes("/payment-result/") &&
    !pathname.includes("/account/my-addresses") &&
    !pathname.includes("/account/create-address") &&
    !pathname.includes("/account/edit-address") &&
    !pathname.includes("/online-") &&
    !pathname.includes("/view-cart");

  return (
    <div style={{ background: "#e6415f" }}>
      <Navbar
        hideCategoryIcon={hideCategoryIcon}
        hideAvatarIcon={hideAvatarIcon}
      />

      {showSimpleNavbar ? <SearchBar flushBottom={pathname === "/"} /> : null}
    </div>
  );
}
